import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#1B4D3E] text-white">
      <div className="container-padding py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-serif text-3xl mb-4">Big Bear Estate</h3>
            <p className="text-white/70 leading-relaxed mb-6">
              The epitome of lake living under the roof of one luxurious, exquisite family residence.
            </p>
            <div className="flex items-center gap-2 text-[#D4AF37]">
              <MapPin className="w-5 h-5" />
              <span>Jack Lake, Apsley, Ontario</span>
            </div>
          </div>

          {/* Property */}
          <div>
            <h4 className="text-sm tracking-widest uppercase font-semibold mb-6 text-[#D4AF37]">
              Property
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/70 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-white/70 hover:text-white transition-colors">
                  Photo Gallery
                </Link>
              </li>
              <li>
                <Link to="/amenities" className="text-white/70 hover:text-white transition-colors">
                  Amenities
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-white/70 hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-white/70 hover:text-white transition-colors">
                  Book Now
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-white/70 hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Explore */}
          <div>
            <h4 className="text-sm tracking-widest uppercase font-semibold mb-6 text-[#D4AF37]">
              Explore
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-white/70 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/location" className="text-white/70 hover:text-white transition-colors">
                  Location Map
                </Link>
              </li>
              <li>
                <Link to="/things-to-do" className="text-white/70 hover:text-white transition-colors">
                  Things to See & Do
                </Link>
              </li>
              <li>
                <Link to="/links" className="text-white/70 hover:text-white transition-colors">
                  Guest Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm tracking-widest uppercase font-semibold mb-6 text-[#D4AF37]">
              Contact
            </h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:416-543-4749" 
                  className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                >
                  <Phone className="w-5 h-5" />
                  416-543-4749
                </a>
              </li>
              <li>
                <a 
                  href="mailto:info@kawartha-luxury-properties.com" 
                  className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                >
                  <Mail className="w-5 h-5" />
                  info@kawartha-luxury-properties.com
                </a>
              </li>
            </ul>
            <div className="mt-6 pt-4 border-t border-white/20">
              <p className="text-white/70 text-sm">
                <strong className="text-white">Kawartha Luxury Properties</strong><br />
                Neill Dixon<br />
                <a href="mailto:neill@neilldixon.com" className="hover:text-white">neill@neilldixon.com</a>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Kawartha Luxury Properties. All rights reserved.
          </p>
          <Link 
            to="/admin/login" 
            className="text-white/50 text-sm hover:text-white/70 transition-colors"
          >
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
